// This file implements things that are specific to a browser

export const JSDOM = null;

// Uses the auto-generated information in `node-env.js` to know which languages
// are available and their aliases.

import hljs from "highlight.js/lib/core";
import { langs } from "./generated-hljs-langs.js";

// bad hack: cannot use async for highlight, since it's used by md-it plainly
// (use a global so it can use a pre-set hook)
globalThis.syncFetch ??= url => {
  const req = new XMLHttpRequest();
  req.open("GET", url, false); req.send(null);
  return req.status === 200 ? req.responseText : null;
};

export const highlight = (str, lang) => {
  const language = langs.find(l => l.includes(lang))?.[0];
  if (!language) return "";
  if (!hljs.getLanguage(language)) {
    const code = globalThis.syncFetch(`/.md.lib/lang/${language}.js`);
    hljs.registerLanguage(
      language,
      Function(`const module = {}; ${code}; return module.exports;`)());
  }
  try   { return hljs.highlight(str, { language }).value; }
  catch { return ""; }
};
